import "angular"; 
import "angular-resource";
import "angular-ui-router";
import idProofController from "./IDProofController";
import idProofFactory from "./IDProofFactory.js";
import mailPinController from "./MailPinController";
import idProofConsentController from "./IDProofConsentController";
import otpNoCodeController from "./otpNoCodeController";
import otpIdentityVerificationController from "./otpIdentityVerificationController";
import otpVerificationCodeEntryController from "./otpVerificationCodeEntryController";
import otpService from "./otpService";
import idProofRouteStates from "./IDProofRoute";
import StateInterceptor from "../core/StateInterceptor";

// eslint-disable-next-line no-undef
var idProof = angular.module('idProof', ['ngResource', 'ui.router',   'focusDirectives']);

idProof.factory('StateInterceptor', StateInterceptor);
 idProof.config(['$httpProvider',function($httpProvider){
$httpProvider.interceptors.push('StateInterceptor');
}]);

idProof.controller('idProofController', idProofController);
idProof.controller('mailPinController', mailPinController);
idProof.controller('idProofConsentController', idProofConsentController);
idProof.controller('otpNoCodeController', otpNoCodeController);
idProof.controller('otpIdentityVerificationController',otpIdentityVerificationController);
idProof.controller('otpVerificationCodeEntryController',otpVerificationCodeEntryController);
idProof.service('otpService', otpService);
idProof.config(idProofRouteStates);
idProof.factory('idProofFactory', idProofFactory);

export default idProof;
